module.exports = __webpack_public_path__ + "img/materials-and-equipments-transfer-hover.daac0bfc.svg";